import { InjectionToken } from '@angular/core';
import { FloatingPanelDockZone } from './floating-panel.types';

/**
 * Injection-token waarmee een content-component dat in een **gedockte** tab
 * gemount wordt weet in welke dock-zone-grootte het gerenderd wordt. Een
 * generieke dock-host (bv. {@link DockAreaComponent}) biedt dit aan zodat
 * inhoud die zich anders wil tonen in een brede (`'full'`) dock-area dan in
 * floating-modus daarop kan reageren — bv. het gate-info panel dat in de
 * full-zone steeds zijn volledige detail-weergave toont, ongeacht de
 * floating-variant waarmee het geopend werd. Niet aangeboden in floating-modus
 * (de content injecteert het `optional`).
 */
export const DOCK_RENDER_ZONE = new InjectionToken<FloatingPanelDockZone>('DOCK_RENDER_ZONE');
